import { CardContainer } from "@msys/ui";
import { Box, Grid } from "@mui/material";
import { Page } from "../../commons/layout/Page.js";
import { PageContainer } from "../../commons/layout/PageContainer.js";

export const ExampleLayoutRightSidebarCard = () => {
  return (
    <>
      <PageContainer>
        <Grid container spacing={2}>
          <Grid
            size={{
              xs: 12,
              lg: 9,
            }}
          >
            <CardContainer title="Gallery">
              <Box
                sx={{
                  height: 300,
                }}
              />
            </CardContainer>
            <CardContainer title="About">
              <Box
                sx={{
                  height: 150,
                }}
              />
            </CardContainer>
          </Grid>
          <Grid
            size={{
              xs: 12,
              lg: 3,
            }}
          >
            <CardContainer title="Cart">
              <Box
                sx={{
                  height: 250,
                }}
              />
            </CardContainer>
          </Grid>
        </Grid>
      </PageContainer>
      <Page>
        <PageContainer>
          <Grid container spacing={2}>
            <Grid
              size={{
                xs: 12,
                lg: 9,
              }}
            >
              <CardContainer title="Description">
                <Box
                  sx={{
                    height: 500,
                  }}
                />
              </CardContainer>
            </Grid>
          </Grid>
        </PageContainer>
      </Page>
    </>
  );
};
